import { Component, Input, OnInit } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";

@Component({
	selector: "caass-scan-point-manual-id-history",
	templateUrl: "./scan-point-manual-id-history.component.html",
	styleUrls: ["./scan-point-manual-id-history.component.css"],
})
export class ScanPointManualIdHistoryComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.loadIDHistoryData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	AudienceMode: any = "Student";
	@Input() FacilityID: any;
	@Input() SelectedPerson: any;

	lstIDHistory: any = [];
	SelectedEntry: any = null;
	cols: any = [
		{ field: "StatusDateStr", header: "Date" },
		{ field: "Barcode", header: "Card" },
		{ field: "StatusDesc", header: "Status" },
	];
	pagefirst: Number = 0;
	pagerows: Number = 5;
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////
	loadIDHistoryData() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var result = this.scanService.RecentIDHistoryGetList("", this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstIDHistory = response;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////////////////////////////
}
